/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { FuneralServiceOperations } from './FuneralService';
import { GiftMessageOperations } from './GiftMessage';
import { GiftMessageFormOperations } from './GiftMessageForm';
import { PersonalizationOperations } from './Personalization';
import { RecipientOperations } from './Recipient';
import { qasAddressOperations } from './AddressQAS';
import { dtwOperations } from './DTW';

const cartItemSagas = [
    ...FuneralServiceOperations.watchers,
    ...GiftMessageOperations.watchers,
    ...GiftMessageFormOperations.watchers,
    ...PersonalizationOperations.watchers,
    ...RecipientOperations.watchers,
    ...dtwOperations.watchers,
    ...qasAddressOperations.watchers,
];

export {
    cartItemSagas,
};

export default {};
